import { z } from 'zod'

export const GetOrganisationSchema = z.object({
  active: z.boolean(),
  id: z.number(),
  name: z.string(),
  short_name: z.string().nullish(),
  slug: z.string(),
})

export type GetOrganisation = z.infer<typeof GetOrganisationSchema>
